// extracted by mini-css-extract-plugin
export default {"container":"src-pages-CustomerDatabaseConfig-CustomerTag-Detail-Filters-Components-SectionWrapper-css-module__container--IDZgk"};